import { BaseModel } from '../../../../../core/base.model';
import { MeasureUnitType, TMeasureUnitType } from '../../../types/measure-unit.type';

export class PurchaseOrder extends BaseModel {
  supplierName: string = '';
  orderDate: string = '';
  status: 'pending' | 'completed' | 'cancelled' = 'pending';
  totalAmount: number = 0;
  items: PurchaseOrderItem[] = [];
}

export class PurchaseOrderItem {
  productId: string;
  productName: string;
  quantity: number;
  measureUnit: TMeasureUnitType;
  unitPrice: number;
  totalPrice: number;

  constructor() {
    this.productId = '';
    this.productName = '';
    this.quantity = 1;
    this.measureUnit = MeasureUnitType.mg;
    this.unitPrice = 0;
    this.totalPrice = 0;
  }
}

export class PurchaseOrderItemValidator {
  validate(item: PurchaseOrderItem): PurchaseOrderItem | null {
    item.quantity = item.quantity * 1.0;
    item.unitPrice = item.unitPrice * 1.0;
    if (!item.productName || item.quantity <= 0 || item.unitPrice < 0) {
      return null;
    }
    item.totalPrice = item.quantity * item.unitPrice;
    return item;
  }
}
